import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import Article from '../article';
import Hero from './hero';
import EntryType from './entry-type';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IMAGES_TO_DISPLAY = 3;
class Accordion extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setEntry", ref => {
      this.entry = ref;
    });
    _defineProperty(this, "handleClick", index => {
      this.setState({
        index
      }, () => {
        this.entry.focus();
      });
    });
    this.state = {
      index: this.props.index
    };
  }
  activeEntries() {
    return this.props.entries.map(entry => _objectSpread(_objectSpread({}, entry), {}, {
      active: this.props.entries.indexOf(entry) === this.state.index
    }));
  }
  entryImages() {
    return this.props.entries.map(entry => entry.image).slice(0, IMAGES_TO_DISPLAY);
  }
  render() {
    const {
      index
    } = this.state;
    const {
      entries,
      heading,
      hasBackground
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: classNames(style.Accordion, {
        [style.hasBackground]: hasBackground
      }),
      "data-id": "accordion_index_div",
      children: [/*#__PURE__*/_jsx(Hero, {
        images: this.entryImages(),
        hasBackground: hasBackground,
        currentImage: entries[index].imageUrl,
        "data-id": "accordion_index_div_Hero"
      }), /*#__PURE__*/_jsx("div", {
        className: style.contentWrapper,
        "data-id": "accordion_index_div_div",
        children: /*#__PURE__*/_jsx("div", {
          className: style.entryList,
          "data-id": "accordion_index_div_div_3",
          children: entries.map((entry, i) => /*#__PURE__*/_jsx("div", {
            className: style.entry,
            tabIndex: "-1",
            ref: this.setEntry,
            "data-id": "accordion_index_div_4",
            children: i === index ? /*#__PURE__*/_jsx(Article, {
              superheading: heading,
              heading: entry.title,
              times: entry.sessions && entry.sessions[0].name === 'Today' && entry.sessions[0].sessions.map(s => s.time).join(' | '),
              location: entry.location,
              className: style.entryArticle,
              link: entry.link,
              occurrences: entry.occurrences,
              "data-id": "accordion_index_Article",
              children: /*#__PURE__*/_jsx(Paragraph, {
                type: "large",
                "data-id": "accordion_index_Article_Paragraph",
                children: entry.body
              })
            }) : /*#__PURE__*/_jsx("button", {
              "aria-expanded": "false",
              className: style.entryTitle,
              onClick: () => this.handleClick(i),
              "data-id": "accordion_index_button",
              children: entry.title
            })
          }, entry.id || entry.slug))
        })
      })]
    });
  }
}
Accordion.defaultProps = {
  index: 0,
  hasBackground: false
};
export default Accordion;